export default __webpack_public_path__ + "static/media/entenda_6_parada_mao.3bfb98f9.jpg";